import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Followers don't matter",
  "description": "",
  "published": "2009-03-31T00:00:00.000Z",
  "redirect_from": ["/blog/?p=477"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`talk about how the number of people you're following matters more than those who follow you`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      